// extracted by mini-css-extract-plugin
export default {"container":"oAlgq0PBesg5ZkQyyd3O"};